import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchProductTags,
  SearchProductTagsVariables
} from "./types/SearchProductTags";

export const searchProductTags = gql`
  ${pageInfoFragment}
  query SearchProductTags($after: String, $first: Int!, $query: String!) {
    search: productTags(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchProductTags,
  SearchProductTagsVariables
>(searchProductTags);
